var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('models/controller',["require", "exports", "services/taskmanager", "models/event"], function (require, exports, Tasks, Event) {
    "use strict";
    var DataColumn = (function () {
        function DataColumn(column) {
            this.column = column;
        }
        return DataColumn;
    }());
    exports.DataColumn = DataColumn;
    var ColumnFilter = (function (_super) {
        __extends(ColumnFilter, _super);
        function ColumnFilter(column, operator, needle, list) {
            _super.call(this, column);
            this.operator = operator;
            this.needle = needle;
            this.list = list;
        }
        ColumnFilter.prototype.build = function () {
            return '';
        };
        ColumnFilter.prototype.isValid = function () {
            return this.needle !== null && this.needle.toString() != "''" && this.needle.toString() !== "";
        };
        return ColumnFilter;
    }(DataColumn));
    exports.ColumnFilter = ColumnFilter;
    var ColumnSort = (function (_super) {
        __extends(ColumnSort, _super);
        function ColumnSort(column, operator) {
            _super.call(this, column);
            this.operator = operator;
        }
        ColumnSort.prototype.build = function () {
            return '';
        };
        return ColumnSort;
    }(DataColumn));
    exports.ColumnSort = ColumnSort;
    var ColumnList = (function () {
        function ColumnList() {
            this._definitions = [];
            this._canRaiseEvent = true;
        }
        ColumnList.prototype.raiseEvent = function () {
            if (this._canRaiseEvent) {
                this._subscription();
            }
        };
        ColumnList.prototype._remove = function (column) {
            this._definitions = Enumerable.From(this._definitions)
                .Where(function (f) { return f != null && f.column != column; })
                .ToArray();
        };
        ColumnList.prototype._add = function (definition) {
            this._definitions.push(definition);
        };
        ColumnList.prototype._attach = function (definitions) {
            var _this = this;
            definitions.forEach(function (f) {
                _this._definitions.push(f);
            });
        };
        ColumnList.prototype.modify = function (action) {
            this._canRaiseEvent = false;
            action(this);
            this._canRaiseEvent = true;
        };
        ColumnList.prototype.subscribe = function (action) {
            this._subscription = action;
        };
        ColumnList.prototype.unsubscribe = function () {
            this._subscription = function () { return console.warn("filter applied!"); };
        };
        ColumnList.prototype.forEach = function (action) {
            this._definitions.forEach(action);
        };
        Object.defineProperty(ColumnList.prototype, "length", {
            get: function () {
                return this._definitions.length;
            },
            enumerable: true,
            configurable: true
        });
        ColumnList.prototype.add = function (definition) {
            this._add(definition);
            this.raiseEvent();
        };
        ColumnList.prototype.attach = function (definitions) {
            this._attach(definitions);
            this.raiseEvent();
        };
        ColumnList.prototype.remove = function (column) {
            this._remove(column);
            this.raiseEvent();
        };
        ColumnList.prototype.replace = function (definition) {
            this._remove(definition.column);
            this._add(definition);
            this.raiseEvent();
        };
        ColumnList.prototype.reAttach = function (column, definitions) {
            this._remove(column);
            this._attach(definitions);
            this.raiseEvent();
        };
        ColumnList.prototype.clear = function () {
            this._definitions.splice(0, this._definitions.length);
            this.raiseEvent();
        };
        return ColumnList;
    }());
    exports.ColumnList = ColumnList;
    var DataController = (function () {
        function DataController() {
            this._isInConfigurationMode = false;
            this._taskManager = new Tasks.Manager();
            this.onLoaded = new Event.Delegate();
            this.result = ko.observableArray();
            this.itemsCount = ko.observable(0);
            this.isLoading = ko.observable(false);
        }
        DataController.prototype.buildUp = function (action) {
            this._isInConfigurationMode = true;
            action(this);
            this._isInConfigurationMode = false;
        };
        DataController.prototype.load = function () {
            var _this = this;
            if (!this._isInConfigurationMode && !this.isLoading()) {
                this.isLoading(true);
                var workStatus = $.t("app:modules.common.message_loadData", { ifMissing: "Daten werden geladen..." });
                this._taskManager.startAsync(workStatus, function () {
                    var result = _this.onLoadAsync();
                    result.finally(function () {
                        _this.isLoading(false);
                        _this.onLoaded.raise(_this, null);
                    });
                    return result;
                });
            }
        };
        DataController.prototype.onLoadAsync = function () {
            alert('not implemented');
            return null;
        };
        return DataController;
    }());
    exports.DataController = DataController;
    var ConfigurableDataController = (function (_super) {
        __extends(ConfigurableDataController, _super);
        function ConfigurableDataController() {
            var _this = this;
            _super.call(this);
            this.sortDefinitions = new ColumnList();
            this.filterDefinitions = new ColumnList();
            this.hideBottomPagination = true;
            this.filterDefinitions.subscribe(function () { return _this.load(); });
            this.sortDefinitions.subscribe(function () { return _this.load(); });
        }
        ConfigurableDataController.prototype.buildFilter = function (column, operator, needle, list) {
            alert('not implemented');
            return null;
        };
        ConfigurableDataController.prototype.buildSort = function (column, operator) {
            alert('not implemented');
            return null;
        };
        return ConfigurableDataController;
    }(DataController));
    exports.ConfigurableDataController = ConfigurableDataController;
    var PageableDataController = (function (_super) {
        __extends(PageableDataController, _super);
        function PageableDataController() {
            _super.apply(this, arguments);
            this.currentPage = ko.observable(1);
            this.pageCount = ko.observable(1);
            this.pageSize = ko.observable(25);
        }
        PageableDataController.prototype.gotoPage = function (page) {
            this.currentPage(page);
            _super.prototype.load.call(this);
        };
        PageableDataController.prototype.load = function () {
            this.currentPage(1);
            _super.prototype.load.call(this);
        };
        return PageableDataController;
    }(ConfigurableDataController));
    exports.PageableDataController = PageableDataController;
});

